<template>
  <div class="editor-container document-viewer">
    <editor-content v-model="content" :editor="editor" />
  </div>
</template>

<script setup>
import { useEditor, EditorContent } from "@tiptap/vue-3";
import { defineEmits, defineProps, ref } from "vue";
import StarterKit from "@tiptap/starter-kit";
import Table from "@tiptap/extension-table";
import TableCell from "@tiptap/extension-table-cell";
import TableHeader from "@tiptap/extension-table-header";
import TableRow from "@tiptap/extension-table-row";
import TaskItem from "@tiptap/extension-task-item";
import TaskList from "@tiptap/extension-task-list";
import TextStyle from "@tiptap/extension-text-style";
import FontFamily from "@tiptap/extension-font-family";
import { Extension } from "@tiptap/core";

const emit = defineEmits(["update:modelValue"]);

const props = defineProps({
  modelValue: {
    type: [String, Object],
    default: "",
  },
});

// Custom extension to preserve all inline styles
const PreserveStyles = Extension.create({
  name: 'preserveStyles',
  
  addGlobalAttributes() {
    return [
      {
        types: ['textStyle'],
        attributes: {
          style: {
            default: null,
            parseHTML: element => element.getAttribute('style'),
            renderHTML: attributes => {
              if (!attributes.style) {
                return {}
              }
              return {
                style: attributes.style,
              }
            },
          },
        },
      },
    ]
  },
})

const content = ref(props.modelValue);

const editor = useEditor({
  content: props.modelValue,
  injectCSS: true,
  extensions: [
    StarterKit,
    TextStyle,
    // Custom extension to preserve all styles
    PreserveStyles,
    FontFamily.configure({
      types: ['textStyle'],
    }),
    Table.configure({
      resizable: true,
    }),
    TableRow,
    TableHeader,
    TableCell,
    TaskItem,
    TaskList,
  ],
  editorProps: {
    handleDOMEvents: {
      beforeinput: (view, event) => {
        event.target.setAttribute('contenteditable', false)
      },
    },
  },
  onUpdate: (val) => {
    content.value = val.editor.getHTML();
    emit("update:modelValue", val.editor.getHTML());
  },
});
</script>